export default {
  CHANGE_LANGUAGE_HANDLER(state, locale) {
    state.selectedLocale = locale;
  },
  SET_ACTIVE_MENU_GROUP_HANDLER(state, router) {
    let fullPath = "";
    if (router.pathURL) {
      fullPath = router.pathURL;
    } else {
      fullPath = router.history.current.fullPath;
    }
    let path = fullPath.split("/");
    let matchedPath = "/" + path[2] + "/" + path[3];
    for (const category in state.sidebarMenu) {
      for (const menuGroup in state.sidebarMenu[category]) {
        if (state.sidebarMenu[category][menuGroup].items !== null) {
          for (const matched in state.sidebarMenu[category][menuGroup].items) {
            if (
              state.sidebarMenu[category][menuGroup].items[matched].path ==
                matchedPath ||
              state.sidebarMenu[category][menuGroup].items[matched].path ==
                fullPath
            ) {
              state.sidebarMenu[category][menuGroup].active = true;
            }
          }
        }
      }
    }
  },

  SET_MODAL_STATE(state, payload) {
    state.isModalOpen = payload;
  },

  SET_VIDEO_MODAL_STATE(state, payload) {
    state.videoModal = payload;
  },

  SET_MODAL_DATA(state, data) {
    state.modalData = data;
  }
};
